import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36612ea2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "user-layout",
  class: "d-flex flex-row flex-fill"
}
const _hoisted_2 = { id: "sidebar-container" }
const _hoisted_3 = {
  id: "main",
  class: "d-flex flex-column flex-fill"
}
const _hoisted_4 = {
  class: "",
  id: "header"
}
const _hoisted_5 = {
  id: "content-wrapper",
  class: "d-flex overflow-auto flex-fill"
}
const _hoisted_6 = {
  id: "content",
  class: "d-flex flex-fill"
}
const _hoisted_7 = { class: "loader-div-40" }
const _hoisted_8 = ["src"]

import CGHeader from "@/core/layout/Header.vue";
import Sidebar from "@/core/layout/Sidebar.vue";
import { loadingOrganization } from "@/core/auth";
import { ASSETS_BASE_URL, DEFAULT_LOGO } from "@/core/logo";

// Idle/session expiry is handled centrally by the session watcher in
// core/vue/startup.ts, so this layout no longer runs its own inactivity timer.

export default /*#__PURE__*/_defineComponent({
  __name: 'User',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Sidebar, { selected: "dashboard" })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(CGHeader)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_7, [
      _createElementVNode("img", {
        src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
        alt: "Loading...",
        class: "loader-logo-40"
      }, null, 8, _hoisted_8)
    ], 512), [
      [_vShow, _unref(loadingOrganization)]
    ])
  ], 64))
}
}

})